import createReactComponent from '../createReactComponent';
var Bug = createReactComponent('Bug', [['rect', {
  width: '8',
  height: '14',
  x: '8',
  y: '6',
  rx: '4',
  key: 'hq8nra'
}], ['path', {
  d: 'M19 7l-3 2',
  key: '2qqzzc'
}], ['path', {
  d: 'M5 7l3 2',
  key: '6t6d7c'
}], ['path', {
  d: 'M19 19l-3-2',
  key: '1q212m'
}], ['path', {
  d: 'M5 19l3-2',
  key: 'cc5cqy'
}], ['path', {
  d: 'M20 13h-4',
  key: '1agfp2'
}], ['path', {
  d: 'M4 13h4',
  key: '1bwh8b'
}], ['path', {
  d: 'M10 4l1 2',
  key: '5v7nwt'
}], ['path', {
  d: 'M14 4l-1 2',
  key: '17bh2z'
}]]);
export default Bug;